import { createFeature } from '@ngrx/store';
import { MonitorSegment } from 'src/app/models/monitor-segments.model';
import { MonitorTrend } from 'src/app/models/monitor-trend.model';

import { MonitorDataPeriod } from 'src/app/services/request-models/get-monitor-data.model';

import { MonitorTargetValues } from './../../models/monitor-value-type.model';
import MonitorReducer from './reducer';

interface MonitorSegmentState {
  score?: number;
  trend?: MonitorTrend;
  advice?: MonitorAdvice;
  currentPeriod?: MonitorDataPeriod;
  previousPeriod?: MonitorDataPeriod;
  targetValues?: MonitorTargetValues;
}

export interface MonitorAdvice {
  adviceText?: string;
}

export interface MonitorState {
  defaultMonitorSegment: MonitorSegment;
  activeMonitorSegment: MonitorSegment | undefined;
  [MonitorSegment.Mow]: MonitorSegmentState | undefined;
  [MonitorSegment.Grass]: MonitorSegmentState | undefined;
  [MonitorSegment.GrassOrganic]: MonitorSegmentState | undefined;
  [MonitorSegment.Maize]: MonitorSegmentState | undefined;
}

export const monitorFeatureKey = 'monitor';

export const monitorFeature = createFeature({
  name: monitorFeatureKey,
  reducer: MonitorReducer,
});
